import { sortBy } from 'lodash'

import { Question } from 'store/questionTypes'

export const getQuestionWithSortedOptions = (question: Question) => ({
  ...question,
  options: sortBy(question.options, ['priority']),
})
